import { FC } from 'react';
import { m } from 'framer-motion';
import Image from 'next/image';
import Empty from './assets/empty.png';
import Full from './assets/full.png';
import s from './CreatorDashboardShimmer.module.scss';

const CreatorDashboardShimmer: FC = () => (
  <m.div
    initial={{ opacity: 0.5 }}
    animate={{ opacity: 1 }}
    transition={{ duration: 1, repeat: Infinity, repeatType: 'mirror' }}
    className={s['creator-dashboard-shimmer']}
  >
    <Image src={Empty} alt="" width={80} height={80} />
    <m.div
      className={s['creator-dashboard-shimmer-content']}
      initial={{ maskImage: 'linear-gradient(0deg, #000000 -10%, #00000000 0%)' }}
      animate={{ maskImage: 'linear-gradient(10deg, #000000 100%, #00000050 200%)' }}
      transition={{ delay: 1, duration: 2 }}
    >
      <Image src={Full} alt="" width={80} height={80} />
    </m.div>
  </m.div>
);

export default CreatorDashboardShimmer;
